/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const SelectEventsMessages = defineMessages({
  events: {
    id: 'Segment.SelectEventsMessages.events',
    defaultMessage: 'Events'
  },
  description: {
    id: 'Segment.SelectEventsMessages.description',
    defaultMessage: 'Description'
  },
  messagesHandled: {
    id: 'Segment.SelectEventsMessages.messagesHandled',
    defaultMessage: 'Message Handled'
  },
  messageHandledDescription: {
    id: 'Segment.SelectEventsMessages.messageHandledDescription',
    defaultMessage: 'Triggering with every turn of conversation'
  },
  sessionStarted: {
    id: 'Segment.SelectEventsMessages.sessionStarted',
    defaultMessage: 'Session Started'
  },
  sessionStartedDescription: {
    id: 'Segment.SelectEventsMessages.sessionStartedDescription',
    defaultMessage:
      'Triggered when conversation first starts (e.g., open chatbot, start phone call)'
  },
  actionStarted: {
    id: 'Segment.SelectEventsMessages.actionStarted',
    defaultMessage: 'Action Started'
  },
  actionStartedDescription: {
    id: 'Segment.SelectEventsMessages.actionStartedDescription',
    defaultMessage: 'Triggered when user’s input (ask) invokes action name'
  },
  actionCompleted: {
    id: 'Segment.SelectEventsMessages.actionCompleted',
    defaultMessage: 'Action Completed'
  },
  actionCompletedDescription: {
    id: 'Segment.SelectEventsMessages.actionCompletedDescription',
    defaultMessage: 'Triggered when all steps in the action are complete'
  },
  selectEvents: {
    id: 'Segment.SelectEventsMessages.selectEvents',
    defaultMessage: 'Select events to send to Segment'
  },
  selectEventsDescription: {
    id: 'Segment.SelectEventsMessages.selectEventsDescription',
    defaultMessage:
      'Assistant will share these events from your {env} environment with Segment.'
  }
});
